export default __webpack_public_path__ + "static/media/lighbulb.12dbb328.svg";